import { Validators } from "@angular/forms";
import { BaseControl, DateTimePicker, TextArea } from "@app/shared";

export class SpecialRadicationForm{
  constructor(){}

  /**
   * Configración formulario

   * @returns {BaseControl<any>[]}
   * @memberof SpecialRadicationForm
   */
   getForm(values?: any): BaseControl<any>[] {
    const fecha_actual = Date.now()
    const controls: BaseControl<any>[] = [
      new DateTimePicker({
        order: 1,
        key: 'dpicker',
        disabled: true,
        hidden: values ? values['fecha_anulacion'] ? false : true : true,
        label: 'Fecha de anulación:',
        pickerMode: 'dialog',
        pickerType: 'calendar',
        value: values ? values['fecha_anulacion'] : fecha_actual,
        maxDate: new Date(),
        class:{
          container: ['form-row col-lg-4 pl-1']
        },
        placeholder: 'Seleccione fecha de anulación',
        validations: {
          validators: [Validators.required],
        }
      }),
      new TextArea({
        key: 'textarea',
        label: 'Motivo de anulación:',
        rows: '3',
        cols: '12',
        notResize: true,
        order: 2,
        value: values ? values['motivo'] : null,
        validations: {
          validators: [Validators.required, Validators.minLength(5)],
          messages: {
            min: 'El motivo de anulación debe ser más extenso.'
          }
        }
      })
    ];
    return controls.sort((a, b) => a.order - b.order);
  }
}


// WEBPACK FOOTER //
// ./src/app/forms/shared/special-radication/shared/special-radication-form.service.ts